import { render, staticRenderFns } from "./EstablishmentInfo.vue?vue&type=template&id=2db98723&scoped=true&lang=html&"
import script from "./EstablishmentInfo.vue?vue&type=script&lang=js&"
export * from "./EstablishmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentInfo.vue?vue&type=style&index=0&id=2db98723&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db98723",
  null
  
)

component.options.__file = "EstablishmentInfo.vue"
export default component.exports